import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { WorkStateEnum } from '../../store/services/b2bMailService';


interface WorkStateIndicatorProps {
  state: number;
  compact?: boolean;
}

const WorkStateIndicator: React.FC<WorkStateIndicatorProps> = ({ state, compact = false }) => {
  const theme = useTheme();

  // Function to determine chip color and label based on WorkState
  const getWorkStateInfo = (state: number) => {
    switch (state) {
      case WorkStateEnum.NotSet:
        return { 
          label: 'Inte satt', 
          color: theme.palette.grey[500],
          textColor: 'white'
        };
      case WorkStateEnum.Open:
        return { 
          label: 'Öppen', 
          color: theme.palette.info.main,
          textColor: 'white'
        };
      case WorkStateEnum.Closed:
        return { 
          label: 'Stängd', 
          color: theme.palette.error.main,
          textColor: 'white'
        };
      case WorkStateEnum.Draft:
        return { 
          label: 'Utkast', 
          color: theme.palette.grey[400],
          textColor: theme.palette.grey[900]
        };
      case WorkStateEnum.Solved:
        return { 
          label: 'Löst', 
          color: theme.palette.success.main,
          textColor: 'white'
        };
      default:
        return { 
          label: 'Okänd', 
          color: theme.palette.grey[500],
          textColor: 'white'
        };
    }
  };

  const { label, color, textColor } = getWorkStateInfo(state);

  return (
    <Chip 
      label={label}
      size={compact ? "small" : "medium"}
      sx={{ 
        bgcolor: color,
        color: textColor,
        fontWeight: 500,
        fontSize: compact ? '0.7rem' : '0.75rem',
        height: compact ? 22 : 24,
        '& .MuiChip-label': {
          px: compact ? 1 : 1.5,
        }
      }}
    />
  );
};

export default WorkStateIndicator;